<template>
  <div @click="changeEyeType" @mouseout="changeEyeTypeColse">
    <!-- <i
      class=""
      :class="!eysShow ? 'fa fa-eye-slash' : 'fa fa-eye'"
    
     
    ></i> -->

    <svg
      class="icon icon-20 float-left eye"
      aria-hidden="true"
      v-if="eysShow === true"
    >
      <use xlink:href="#icon-v4_27"></use>
    </svg>
    <svg
      v-if="eysShow === false"
      class="icon icon-20 float-left eye"
      aria-hidden="true"
      @click="changeEyeType"
      @mouseout="changeEyeTypeColse"
    >
      <use xlink:href="#icon-v4_27_h"></use>
    </svg>
  </div>
</template>

<script>
import { set } from "vue";
export default {
  name: "eyePassword",
  props: {
    passwordType: {
      type: Object,
      default: { inputType: "password", label: "" },
    },
  },
  data() {
    return {
      eysShow: false, // false-小眼睛为关闭状态，true-小眼睛为开启状态
    };
  },
  methods: {
    //点击小眼睛显示密码
    changeEyeType() {
      setTimeout(() => {
        this.eysShow = true;
        this.$emit("currentType", {
          inputType: "text",
          label: this.passwordType.label,
        });
      }, 300);
    },
    //小眼睛鼠标移出，密码显示……
    changeEyeTypeColse() {
      this.eysShow = false;
      this.$emit("currentType", {
        inputType: "password",
        label: this.passwordType.label,
      });
    },
  },
};
</script>

<style scoped>
.eye {
  float: right;
}
.eye:hover {
  cursor: pointer;
}
</style>
